(function () {
  var drawer = document.querySelector('[data-cart-drawer]');
  if (!drawer) return;

  var itemsEl = drawer.querySelector('[data-cart-drawer-items]');
  var emptyEl = drawer.querySelector('[data-cart-drawer-empty]');
  var footerEl = drawer.querySelector('[data-cart-drawer-footer]');
  var subtotalEl = drawer.querySelector('[data-cart-drawer-subtotal]');
  var shippingTextEl = drawer.querySelector('[data-cart-drawer-shipping-text]');
  var shippingBarEl = drawer.querySelector('[data-cart-drawer-shipping-bar]');
  var recommendationsEl = drawer.querySelector('[data-cart-drawer-recommendations]');
  var recommendationsListEl = drawer.querySelector('[data-cart-drawer-recommendations-list]');

  var freeShippingThresholdCents =
    (parseFloat(drawer.getAttribute('data-free-shipping-threshold-eur')) || 89) * 100;

  var lastAddedProductId = null;
  var currentCart = null;

  function formatMoney(cents) {
    var amount = (cents / 100).toFixed(2).replace('.', ',');
    var parts = amount.split(',');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
    return parts.join(',') + ' €';
  }

  function getFreeShippingThreshold(cart) {
    if (cart && cart.cart_level_discount_applications) {
      for (var i = 0; i < cart.cart_level_discount_applications.length; i++) {
        var application = cart.cart_level_discount_applications[i];
        if (application.target_type === 'shipping_line' && application.value_type === 'percentage') {
          return 0;
        }
      }
    }

    return freeShippingThresholdCents;
  }

  function openDrawer() {
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('cart-drawer-open');
  }

  function closeDrawer() {
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('cart-drawer-open');
  }

  function renderShippingBar(cart) {
    var threshold = getFreeShippingThreshold(cart);
    var remaining = threshold - cart.total_price;

    if (remaining <= 0) {
      shippingTextEl.textContent = 'Onneksi olkoon! Saat ilmaisen toimituksen.';
      shippingBarEl.style.width = '100%';
    } else {
      shippingTextEl.textContent = formatMoney(remaining) + ' jäljellä ilmaiseen toimitukseen';
      var percent = threshold > 0 ? Math.min(100, (cart.total_price / threshold) * 100) : 100;
      shippingBarEl.style.width = percent + '%';
    }
  }

  function renderItem(item) {
    var el = document.createElement('div');
    el.className = 'cart-drawer__item';
    el.setAttribute('data-cart-drawer-item', '');
    el.setAttribute('data-key', item.key);

    var variantText = item.variant_title
      ? '<div class="cart-drawer__item-variant">' + item.variant_title + '</div>'
      : '';
    var image = item.image || '';

    el.innerHTML =
      '<div class="cart-drawer__item-image">' +
        '<a href="' + item.url + '"><img src="' + image + '" alt="' + item.product_title + '" loading="lazy"></a>' +
      '</div>' +
      '<div class="cart-drawer__item-details">' +
        '<a class="cart-drawer__item-title" href="' + item.url + '">' + item.product_title + '</a>' +
        variantText +
        '<div class="cart-drawer__item-price">' + formatMoney(item.final_line_price) + '</div>' +
        '<div class="cart-drawer__item-qty">' +
          '<button type="button" class="cart-drawer__qty-btn" data-cart-drawer-decrease aria-label="Vähennä määrää">-</button>' +
          '<span class="cart-drawer__qty-value">' + item.quantity + '</span>' +
          '<button type="button" class="cart-drawer__qty-btn" data-cart-drawer-increase aria-label="Lisää määrää">+</button>' +
        '</div>' +
      '</div>' +
      '<button type="button" class="cart-drawer__item-remove" data-cart-drawer-remove aria-label="Poista tuote">&times;</button>';

    return el;
  }

  function renderCart(cart) {
    currentCart = cart;
    itemsEl.innerHTML = '';

    if (cart.item_count === 0) {
      emptyEl.hidden = false;
      footerEl.hidden = true;
      itemsEl.hidden = true;
      if (recommendationsEl) recommendationsEl.hidden = true;
    } else {
      emptyEl.hidden = true;
      footerEl.hidden = false;
      itemsEl.hidden = false;

      cart.items.forEach(function (item) {
        itemsEl.appendChild(renderItem(item));
      });
    }

    subtotalEl.textContent = formatMoney(cart.total_price);
    renderShippingBar(cart);
  }

  function renderRecommendation(product) {
    var variant = (product.variants || []).find(function (v) {
      return v.available;
    }) || product.variants[0];

    var el = document.createElement('div');
    el.className = 'cart-drawer__recommendation';

    var image = product.featured_image || (product.images && product.images[0]) || '';

    var priceHtml = formatMoney(product.price);
    if (product.compare_at_price && product.compare_at_price > product.price) {
      priceHtml +=
        '<span class="cart-drawer__recommendation-price-compare">' + formatMoney(product.compare_at_price) + '</span>';
    }

    el.innerHTML =
      '<a class="cart-drawer__recommendation-image" href="' + product.url + '">' +
        '<img src="' + image + '" alt="' + product.title + '" loading="lazy">' +
      '</a>' +
      '<a class="cart-drawer__recommendation-title" href="' + product.url + '" title="' + product.title + '">' +
        product.title +
      '</a>' +
      '<div class="cart-drawer__recommendation-price">' + priceHtml + '</div>' +
      '<button type="button" class="cart-drawer__recommendation-add" data-cart-drawer-recommendation-add' +
        (variant ? ' data-variant-id="' + variant.id + '"' : ' disabled') +
      '>+ Osta</button>';

    return el;
  }

  function renderRecommendations(products) {
    if (!recommendationsEl || !recommendationsListEl) return;

    recommendationsListEl.innerHTML = '';

    if (!products || products.length === 0) {
      recommendationsEl.hidden = true;
      return;
    }

    products.slice(0, 4).forEach(function (product) {
      recommendationsListEl.appendChild(renderRecommendation(product));
    });

    recommendationsEl.hidden = false;
  }

  function fetchRecommendations(productId) {
    if (!recommendationsEl || !productId) return;

    fetch('/recommendations/products.json?product_id=' + productId + '&limit=4', {
      headers: { Accept: 'application/json' }
    })
      .then(function (res) {
        return res.json();
      })
      .then(function (data) {
        renderRecommendations(data.products);
      })
      .catch(function () {
        recommendationsEl.hidden = true;
      });
  }

  function fetchCart() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (res) {
      return res.json();
    });
  }

  function refreshCart() {
    return fetchCart().then(renderCart);
  }

  function changeItem(key, quantity) {
    var payload = { quantity: quantity };

    var line = 0;
    if (currentCart && currentCart.items) {
      for (var i = 0; i < currentCart.items.length; i++) {
        if (currentCart.items[i].key === key) {
          line = i + 1;
          break;
        }
      }
    }

    if (line > 0) {
      payload.line = line;
    } else {
      payload.id = key;
    }

    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(payload)
    })
      .then(function (res) {
        return res.json();
      })
      .then(function (cart) {
        if (!cart || !cart.items) {
          return refreshCart();
        }
        renderCart(cart);
        updateHeaderCount(cart.item_count);
      });
  }

  function updateHeaderCount(count) {
    document.querySelectorAll('[data-header-cart-count]').forEach(function (el) {
      el.textContent = count > 0 ? count : '';
      el.classList.toggle('visible', count > 0);
      el.setAttribute('data-header-cart-count', count > 0 ? count : '');
    });
  }

  function addToCart(formOrPayload) {
    var fetchOptions = { method: 'POST', headers: { Accept: 'application/json' } };

    if (formOrPayload instanceof HTMLFormElement) {
      fetchOptions.body = new FormData(formOrPayload);
    } else {
      fetchOptions.headers['Content-Type'] = 'application/json';
      fetchOptions.body = JSON.stringify(formOrPayload);
    }

    return fetch('/cart/add.js', fetchOptions)
      .then(function (res) {
        if (!res.ok) return res.json().then(function (err) { throw err; });
        return res.json();
      })
      .then(function (addedItem) {
        lastAddedProductId = addedItem.product_id;
        return fetchCart();
      })
      .then(function (cart) {
        renderCart(cart);
        updateHeaderCount(cart.item_count);
        fetchRecommendations(lastAddedProductId);
        openDrawer();
      });
  }

  itemsEl.addEventListener('click', function (e) {
    var itemEl = e.target.closest('[data-cart-drawer-item]');
    if (!itemEl) return;

    var key = itemEl.getAttribute('data-key');

    if (e.target.closest('[data-cart-drawer-remove]')) {
      changeItem(key, 0);
      return;
    }

    if (e.target.closest('[data-cart-drawer-increase]')) {
      var qtyEl = itemEl.querySelector('.cart-drawer__qty-value');
      changeItem(key, parseInt(qtyEl.textContent, 10) + 1);
      return;
    }

    if (e.target.closest('[data-cart-drawer-decrease]')) {
      var qtyEl2 = itemEl.querySelector('.cart-drawer__qty-value');
      var newQty = parseInt(qtyEl2.textContent, 10) - 1;
      changeItem(key, newQty);
      return;
    }
  });

  if (recommendationsListEl) {
    recommendationsListEl.addEventListener('click', function (e) {
      var button = e.target.closest('[data-cart-drawer-recommendation-add]');
      if (!button || button.disabled) return;

      var variantId = button.getAttribute('data-variant-id');
      if (!variantId) return;

      button.disabled = true;
      addToCart({ id: variantId, quantity: 1 }).then(
        function () {
          button.disabled = false;
        },
        function () {
          button.disabled = false;
        }
      );
    });
  }

  drawer.querySelectorAll('[data-cart-drawer-close]').forEach(function (el) {
    el.addEventListener('click', closeDrawer);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && drawer.classList.contains('is-open')) {
      closeDrawer();
    }
  });

  // Cart icon (header) and any other [data-cart-drawer-toggle] trigger
  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-cart-drawer-toggle]');
    if (!trigger) return;

    e.preventDefault();
    refreshCart();
    openDrawer();
  });

  // Intercept every "Add to cart" form submission (product page, quickshop, quick-buy)
  // before the theme's own AJAX handler runs, so the product is added exactly once
  // and our drawer opens instead of the theme's flyout notification.
  document.addEventListener(
    'submit',
    function (e) {
      var form = e.target.closest('[data-product-form]');
      if (!form) return;

      var submitter = e.submitter;
      if (submitter && submitter.id !== 'AddToCart') return;

      e.preventDefault();
      e.stopImmediatePropagation();
      addToCart(form);
    },
    true
  );

  // Intercept collection grid "Lisää ostoskoriin" (quick buy) buttons before the
  // theme's own AJAX handler runs, so it adds the product exactly once and opens
  // our drawer instead of the theme's flyout notification.
  document.addEventListener(
    'click',
    function (e) {
      var button = e.target.closest('[data-quick-buy]');
      if (!button || button.disabled || button.classList.contains('disabled')) return;

      var variantId = button.getAttribute('data-variant-id');
      if (!variantId) return;

      e.preventDefault();
      e.stopImmediatePropagation();
      addToCart({ id: variantId, quantity: 1 });
    },
    true
  );
})();
